// extracted by mini-css-extract-plugin
export default {"glitter":"NgenStarProBadge_glitter__4uM5r"};